import { CSSProperties } from '@mui/styles';

import { pStyle } from '../styles';

export const forgotPStyle = { ...pStyle, margin: 0 };

export const signInTypographyStyle: CSSProperties = {
  textAlign: 'right',
  fontSize: '12px',
  lineHeight: '16px',
};

export const signInInsidePaper = { margin: '0px auto', width: '315px' };
